<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg2" ref="statisTitle">
            <span>全过程行为分析</span>
            <!--<span v-if="name==='teaBehavior'">教师学生行为分析</span>-->
            <!--<span v-else>学生行为分析</span>-->
        </div>
        <div class="content" :style="contentStyleObj">
            <div style="float: left;" class="pict-box">
                <div style="width:100%;height:100%;" id="data_pie1"></div>
                <Tooltip placement="top" class="tip" max-width="200" v-if="paramTeaData.length > 0">
                    <img :src="require(`@/assets/images/tip_1.png`)" />
                    <div slot="content">
                        <p>1、课前：统计智能备课助手课堂活动等模块数据</p>
                        <p>2、课中：统计大屏、PC以及移动教师端的白板、课本、讲评、互动、智能板、拍照、展台以及同屏等模块数据</p>
                        <p>3、课后：统计备课端PC以及移动授课助手的作业模块数据</p>
                    </div>
                </Tooltip>
            </div>
            <div style="float: right;" class="pict-box">
                <div style="width:100%;height:100%;" id="data_pie2"></div>
                <Tooltip placement="top" class="tip" max-width="200" v-if="paramStuData.length > 0">
                    <img :src="require(`@/assets/images/tip_1.png`)" />
                    <div slot="content">
                        <p>1、课前：统计C30学生端的微课中心和通知&问老师模块数据</p>
                        <p>2、课中：统计C30学生端的课堂活动模块数据</p>
                        <p>3、课后：统计C30学生端的作业、错题本、复习资料、课堂笔记和课堂评价模块数据</p>
                    </div>
                </Tooltip>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "pie-item",
    data() {
        return {
            screenWidth: 0, //屏幕宽度
            // styleObj: {
            //     height: ''
            // },
            boxWrapStyleObj: {
                height: ''
            },
            contentStyleObj: {
                height: '',
                marginTop: '0px'
            },
            pieData: [],
            channel: process.env.VUE_APP_CHANNEL,
            defaultPointList: [],
            smallPieColorArr: ['#4180FF', '#018AE6', '#03C4B0'],
            bigPieColorArr: ['#0368E3', '#329ED6', '#26C0E2', '#A0E3BA', '#FFDD84', '#F39C83', '#F36D81', '#E581AD', '#E2BFE9', '#7672ED']
        }
    },
    props: {
        name: String,
        schoolId: String,
        schoolName: String,
        form: String,
        paramTeaData: {
            type: Array,
            default: function () {
                return []
            }
        },
        paramStuData: {
            type: Array,
            default: function () {
                return []
            }
        },
        screenHeight: Number,
        titleHeight: Number
    },
    watch: {
        'screenHeight': 'initBoxHeight',
        'titleHeight': 'initBoxHeight',
        // 'paramData': 'loadPieByParamName',
        'paramTeaData': 'loadTeaPie',
        'paramStuData': 'loadStuPie'
    },
    methods: {
        /**
         * 初始化box高度
         */
        initBoxHeight() {
            let winHeight = window.innerHeight;
            if (winHeight < 900) {
                winHeight = 938;
            }
            let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
            let contentHeight = boxWrapHeight - this.$refs.statisTitle.offsetHeight - 10;
            this.boxWrapStyleObj.height = boxWrapHeight + 'px';
            this.contentStyleObj.height = contentHeight + 'px';
        },
        /**
         * 根据参数name动态加载饼图
         */
        loadPieByParamName() {
            if (this.name === 'stuBehavior') {
                // 加载学生行为
                this.initPie('data_pie2');
            } else {
                // 加载教师行为
                this.initPie('data_pie1');
            }
        },
        /**
         * 加载教师行为
         */
        loadTeaPie() {
            // 加载教师行为
            this.initPie('data_pie1', this.paramTeaData);
        },
        /**
         * 加载学生行为
         */
        loadStuPie() {
            // 加载学生行为
            this.initPie('data_pie2', this.paramStuData);
        },
        /**
         * 加载饼状图
         */
        initPie(id, data) {
            let _this = this;
            if (data.length > 0) {
                _this.pieData = _this.copyParamData(data);
                let dataSourcePie = this.$echarts.init(document.getElementById(id));
                let bigPieColorList = [];
                let smallPieColorList = [];
                for (let i = 0; i < _this.pieData.length; i++) {
                    smallPieColorList.push(_this.smallPieColorArr[i]);
                }
                for (let i = 0; i < _this.defaultPointList.length; i++) {
                    bigPieColorList.push(_this.bigPieColorArr[i]);
                }

                let fontSize = 12;
                let smallPieRadius = "40%";
                let bigPieRadiusStart = "55%";
                let bigPieRadiusEnd = "70%";
                let smallMinAngle = 5;
                let bigMinAngle = 10;
                if (this.screenWidth <= 1680) {
                    fontSize = 9;
                    smallMinAngle = 10;
                    bigMinAngle = 18;
                }
                if (this.screenWidth <= 1028) {
                    fontSize = 8;
                    smallMinAngle = 10;
                    bigMinAngle = 18;
                }
                const option = {
                    title: {
                        text: id === 'data_pie1' ? '教师行为分析' : '学生行为分析',
                        x: 'center',
                        textStyle: {
                            color: '#708acc',
                            fontSize: 14
                        },
                        top: '0'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b}: {c} ({d}%)"
                    },
                    series: [
                        {
                            name: '',
                            type: 'pie',
                            minAngle: smallMinAngle,           　　 //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                            avoidLabelOverlap: true,   //是否启用防止标签重叠策略
                            selectedMode: 'single',
                            radius: [0, smallPieRadius],
                            center: ['50%', '58%'], // 图的位置
                            label: {
                                normal: {
                                    position: 'inner',
                                    fontSize: fontSize
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data: _this.pieData,
                            color: smallPieColorList
                        },
                        {
                            name: '',
                            type: 'pie',
                            minAngle: bigMinAngle,           　　 //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                            avoidLabelOverlap: true,   //是否启用防止标签重叠策略
                            radius: [bigPieRadiusStart, bigPieRadiusEnd],
                            center: ['50%', '58%'], // 图的位置
                            label: {
                                normal: {
                                    formatter: '{b}',
                                    fontSize: fontSize
                                }
                            },
                            labelLine: {
                                normal: {
                                    length: 12,
                                    length2: 12
                                }
                            },
                            data: _this.defaultPointList,
                            color: bigPieColorList
                        }
                    ]
                };
                dataSourcePie.clear();
                let isNotMerge = true;
                dataSourcePie.setOption(option, true);
                // 处理点击事件
                dataSourcePie.on('click', function (params) {
                    if (params.seriesIndex == 0) {
                        for (var i = 0; i < option.series[0].data.length; i++) {
                            option.series[0].data[i].selected = false;
                        }
                        option.series[0].data[params.dataIndex].selected = true;
                        option.series[1].data = option.series[0].data[params.dataIndex].pointList;
                        dataSourcePie.clear();
                        dataSourcePie.setOption(option);
                    }
                    else {
                        if (_this.channel != 'sy') {
                            if (_this.form == 'region' || (_this.form == 'school' && _this.schoolId != undefined)) {
                                let name = _this.form == 'region' ? 'regionuseractionanalyse' : 'useractionanalyse';
                                let routeData = _this.$router.resolve({
                                    name: name,
                                    query: {
                                        schoolId: _this.schoolId,
                                        schoolName: _this.schoolName,
                                        userState: id === 'data_pie1' ? 'teacher' : 'student',
                                        form: _this.form,
                                    }
                                });
                                window.open(routeData.href, "_blank");
                            }
                        }

                    }
                });
                window.addEventListener('resize', function () {
                    dataSourcePie.resize();
                });
            }
        },
        /**
         * 根据参数数组加载饼状图
         */
        copyParamData(list) {
            let _this = this;
            let _pieData = [];
            _this.defaultPointList = [];
            for (let i = 0; i < list.length; i++) {
                let pieItemObj = {};
                pieItemObj.name = list[i].sceneName;
                pieItemObj.value = list[i].count;
                pieItemObj.selected = false;
                pieItemObj.pointList = [];

                for (let j = 0; j < list[i].pointList.length; j++) {
                    let pointObj = {};
                    pointObj.name = list[i].pointList[j].displayName;
                    pointObj.value = list[i].pointList[j].count;

                    pieItemObj.pointList.push(pointObj);
                    _this.defaultPointList.push(pointObj);
                }
                _pieData.push(pieItemObj);
            }
            return _pieData;

        }
    },
    mounted() {
        //获取屏幕宽度
        this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";

.bg2 {
    background-image: url("../../../assets/images/databoard/title-bg2.png");
}
</style>
<style lang="scss">
.tip {
    .ivu-tooltip-popper {
        min-width: 200px;
    }
}
</style>
